import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SendUserDataUseCase } from '../../core/domain/billing/usecases/sendUserData.usecase';
import { BillingRepository } from '@/core/domain/billing/repositories/billing.repository';
import { BillingImplRepository } from './billing-imp.repository';
import { StoreBillingDataUseCase } from '@/core/domain/billing/usecases/storeBilling.usecase';

const SendUserDataUseCaseFactory = (billingRepository: BillingRepository) =>
    new SendUserDataUseCase(billingRepository);

const StoreBillingDataUseCaseFactory = (billingRepository: BillingRepository) =>
    new StoreBillingDataUseCase(billingRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: SendUserDataUseCase,
            useFactory: SendUserDataUseCaseFactory,
            deps: [BillingRepository],
        },
        {
            provide: BillingRepository,
            useClass: BillingImplRepository,
        },
        {
            provide: StoreBillingDataUseCase,
            useFactory: StoreBillingDataUseCaseFactory,
            deps: [BillingRepository],
        },
    ],
})
export class BillingDataModule {}
